import React from 'react'
import { Button, ButtonVariant } from '@local/do-secundo-button'
import { Modal } from '@local/do-secundo-modal'
import Warning from '../../assets/warning-outline.svg'
import styles from './MenuPage.error.module.css'
import { RestaurantInfo } from '../../types/config'
import { formatPhoneNumberFromCountryIso } from '../../utils/phone-utils'
import { CountryIsoCode } from '@toasttab/buffet-pui-country-utilities'
import { t } from '@local/translations'

interface Props {
  restaurantInfo?: RestaurantInfo
  countryCode?: CountryIsoCode
}

export const MenuPageError = ({ restaurantInfo, countryCode }: Props) => {
  const phoneNumber = restaurantInfo?.address?.phone

  return (
    <div className={styles.error}>
      <Modal responsive={false}>
        <div className={styles.modal}>
          <Warning />
          <h1 className={styles.header}>{t('menu-page-error.header')}</h1>
          <p className={styles.text}>
            {t(
              phoneNumber
                ? 'menu-page-error.description-with-phone'
                : 'menu-page-error.description'
            )}
            {phoneNumber && (
              <a
                className='pl-1 whitespace-nowrap text-link'
                href={`tel:${phoneNumber}`}
              >
                {formatPhoneNumberFromCountryIso(phoneNumber, countryCode)}
              </a>
            )}
            .
          </p>
          <p className={styles.text}>{t('menu-page-error.vpn-warning')}</p>
          <Button
            onClick={() => window.location.reload()}
            variant={ButtonVariant.LINK_WIDE}
            data-testid='retry-button'
          >
            {t('menu-page-error.try-again')}
          </Button>
        </div>
      </Modal>
    </div>
  )
}
